(function () {
  var fly = document.getElementById('decrinito-fly');
  if (!fly) return;

  var fx = window.innerWidth / 2;
  var fy = window.innerHeight / 2 + (window.scrollY || 0);
  var vx = 1.2;
  var vy = 0.8;
  var mx = fx;
  var my = fy;
  var scared = false;
  var currentAngle = 90;

  document.addEventListener('mousemove', function (e) {
    mx = e.clientX;
    my = e.clientY + (window.scrollY || 0);
  });

  fly.addEventListener('click', function () {
    scared = true;
    vx += (Math.random() - 0.5) * 10;
    vy += (Math.random() - 0.5) * 10;
  });

  document.addEventListener('touchstart', function (e) {
    var t = e.touches[0];
    var tx = t.clientX;
    var ty = t.clientY + (window.scrollY || 0);
    var dx = fx - tx;
    var dy = fy - ty;
    if (Math.sqrt(dx * dx + dy * dy) < 60) {
      scared = true;
      vx += (Math.random() - 0.5) * 10;
      vy += (Math.random() - 0.5) * 10;
    }
  }, { passive: true });

  function lerpAngle(current, target, t) {
    var diff = target - current;
    while (diff > 180) diff -= 360;
    while (diff < -180) diff += 360;
    return current + diff * t;
  }

  function animate() {
    var scrollY = window.scrollY || 0;
    var W = window.innerWidth;
    var H = window.innerHeight;

    var dist = Math.sqrt((fx - mx) * (fx - mx) + (fy - my) * (fy - my));

    if (dist < 80 || scared) {
      scared = true;
      var angle = Math.atan2(fy - my, fx - mx);
      vx += Math.cos(angle) * 0.6;
      vy += Math.sin(angle) * 0.6;
      if (dist > 200) scared = false;
    } else {
      vx += (Math.random() - 0.5) * 0.4;
      vy += (Math.random() - 0.5) * 0.4;
      if (Math.random() < 0.02) {
        vx += (mx - fx) * 0.003;
        vy += (my - fy) * 0.003;
      }
    }

    var speed = Math.sqrt(vx * vx + vy * vy);
    var maxSpeed = scared ? 5 : 2.5;
    if (speed > maxSpeed) {
      vx = (vx / speed) * maxSpeed;
      vy = (vy / speed) * maxSpeed;
    }

    vx *= 0.97;
    vy *= 0.97;

    fx += vx;
    fy += vy;

    var margin = 20;
    if (fx < margin) { fx = margin; vx = Math.abs(vx) * 0.7; }
    if (fx > W - margin) { fx = W - margin; vx = -Math.abs(vx) * 0.7; }
    if (fy < scrollY + margin) { fy = scrollY + margin; vy = Math.abs(vy) * 0.7; }
    if (fy > scrollY + H - margin) { fy = scrollY + H - margin; vy = -Math.abs(vy) * 0.7; }

    var targetAngle = Math.atan2(vy, vx) * 180 / Math.PI + 90;
    currentAngle = lerpAngle(currentAngle, targetAngle, 0.12);

    fly.style.left = (fx - 10) + 'px';
    fly.style.top = (fy - scrollY - 10) + 'px';
    fly.style.transform = 'rotate(' + currentAngle + 'deg)';

    requestAnimationFrame(animate);
  }

  animate();
})();